// extracted by mini-css-extract-plugin
export var body = "industry-intro-module--body--2e5f7";
export var comingSoon = "industry-intro-module--comingSoon--f6edb";
export var deck = "industry-intro-module--deck--34c12";
export var description = "industry-intro-module--description--2dad2";
export var intro = "industry-intro-module--intro--d3794";